module.exports = __webpack_public_path__ + "assets/img/footBg.ca040be0.png";